
const sounds = {
    nom: new Audio('nom.wav'),
    sacrificeComplete: new Audio('sacrifice_complete.wav'),
    gameover: new Audio('gameover.wav')
};

export default sounds;


// WEBPACK FOOTER //
// ./src/model/sounds.js